import bulkItemAPI from './bulkItemAPI';
import singleItemAPI from './singleItemAPI';

export default {
  single: singleItemAPI,
  bulk: bulkItemAPI,
};
